// Analytics module exports
export { playerIdManager } from './PlayerId';
export {
  identifyPlayer,
  trackLevelStarted,
  trackLevelFinished,
  trackLevelFailed,
  trackLevelAbandoned,
  trackLevelRestarted,
  trackHintViewed,
  trackEnemyRangeChecked,
  trackVisionViewed,
  trackSolutionReplayStarted,
  trackSolutionReplayExited,
} from './AnalyticsTracker';
